export default __webpack_public_path__ + "static/media/github.16f60ebf.svg";